module.exports = __webpack_public_path__ + "assets/img/ldc.28ce04f0.png";